import { useState } from "react";
import Menu from '../menu/Menu';
import TermsConditions from "./TermsConditions";



export default function TermsConditionsScreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <TermsConditions onOpenMenu={() => setIsMenuOpen(true)} />
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}
